<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="现金银行登记账"
      :page="true"
      show-index
      :show-query="true"
      :get-data-func="api.list2"
      :reset-data-func="resetDataFunc"
      :query-before="queryBefore"
      show-checkbox
      @check-change="(x) => (Rows = x)"
      :queryParamsAppend="{}"
      v-if="trendShow"
      urlHash="finance/cashier/cashbanks"
      @selectClick="selectClick"
      @getDataEnd="getDataEnd"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import empDialog from "@/components/personnel/result/record/listDialog";

export default {
  mixins: [listMixin],
  components: { list, empDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/rp/bankCheckIn").default,
      trendShow: true,
      currentRow: null,
      AccountId: 0,
      AccountName: 0,
      Rows: [],
      DelData: [],
    };
  },

  mounted() {
    if (!this.$permission.canPrice("/finance/cashier/cashbanks")) {
      const findIndex = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "InAmount"
      );
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
      const findIndex1 = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "OutAmount"
      );
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1);
      const findIndex2 = this.$refs.list.tableList.findIndex(
        (item) => item.tableName == "LeftAmountOrg"
      );
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1);
    }
  },
  methods: {
    getDataEnd(resData) {
      console.log(resData, "resData");
      resData.forEach((item) => {
        if (item.SourceNo == "" || item.SourceNo == null) {
          // if (item.Direction == '贷') {
          //   item.InAmount_disabled = true;
          // } else {
          //   item.OutAmount_disabled = true;
          // }
          return;
        }
        item.CheckInDate_disabled = true;
        item.AbstractId_disabled = true;
        item.SettleId_disabled = true;
        item.NoteDate_disabled = true;
        item.TicketNumber_disabled = true;
        item.InAmount_disabled = true;
        item.OutAmount_disabled = true;
        item.LeftAmountOrg_disabled = true;
        item.EmpName_disabled = true;
      });
      // this.$refs.list.setTable(this.Combination);
    },
    selectClick(row) {
      this.currentRow = row;
      console.log("外层list触发", row);
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      this.currentRow.EmpId = data.EmpId;
      this.currentRow.EmpName = data.EmpName;
      this.currentRow.DpName = data.DpName;
      this.currentRow.DpId = data.DpId;
      this.currentRow.T = 1;
    },

    resetDataFunc(data) {
      this.api.getAmount({ AccountId: this.AccountId }).then((res) => {
        if (res.Data) {
          this.NowAmount = res.Data.Amount;
          localStorage.setItem("NowAmount", this.NowAmount);
        }
      });
      console.log("data=====", data);
      return data;
      // console.log('data', data)
      // if(data.length === 0){
      //   this.$refs.list.data = data;

      //   this.newLine();

      //   return this.$refs.list.data
      // }else{
      //   return data
      // }
    },
    queryBefore() {
      let item = this.$refs.list.paramsData.filter((item) => {
        return item.field === "AccountId";
      })[0];

      if (!item.value) {
        this.$message({
          type: "warning",
          message: "温馨提示，选择账号后才能查询",
        });
        return false;
      } else {
        this.AccountId = item.value;
        this.AccountName = item.label;

        return true;
      }
    },
    newLine() {
      let o = {
        BankCheckInId: 0,
        AccountId: this.AccountId,
        AccountName: this.AccountName,
        // ClassId: this.params.ClassId,
        // ClassName: this.params.ClassName,
        CheckInDate: this.$commonJs.getToday(), //日期
        NoteDate: this.$commonJs.getToday(), //票据日期
        CashierNo: "", //出纳票号
        TicketNumber: "", //票号
        // AbstractId: null, //摘要
        Abstract: "", //摘要
        SettleId: null, //结算方式Id
        InAmount: null, //借（收入）金额
        OutAmount: null, //贷（支出）金额
        LeftAmountOrg: null,
        EmpId: null, //经手人
        EmpName: "",
        DpId: null, //经办部门
        DpName: "",
        TradeUnitId: null, //对方单位
        TradeUnitAccountId: null, //对方账号
        TradeUnitAccountName: "", //账号名称
        BankNo: "", //银行号码
        // SourceId: null, //来源单据
        // SoruceTypeId: null,
        // ReceiptDtsId: null, //收款单收款Id
        // PayDtsDtsId: null, //付款单付款Id
        // MakeEmpId: null, //制单人Id
        // MakeDate: null, //制单日期
        T: 0,
      };
      this.$refs.list.data.push(o);
    },
    onDelete() {
      if (this.Rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      if (
        this.Rows.some((item) => item.SourceNo != "" && item.SourceNo != null)
      ) {
        this.$message.warning("请重新选择，有来源单据的数据无法删除！");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("删除", this.Rows);
          var data = this.$refs.list.data;
          var removeData = this.Rows.filter((x) => x.BankCheckInId > 0);
          var ids = removeData.map((x) => x.BankCheckInId);

          this.Rows.forEach((x) => {
            if (x.T != 0) this.DelData.push({ ...x, T: 2 });
            var index = data.indexOf(x);
            this.$refs.list.data.splice(index, 1);
          });

          if (ids.length > 0) {
            this.api.delete({ ids: ids }).then((res) => {
              if (res.Code == 0) {
                this.$message.success("删除成功");
                this.reload();
              } else {
                this.$message.error("删除失败");
                this.reload();
              }
            });
          }
          console.log("this.DelData", this.DelData);
        })
        .catch(() => {});
    },
    save() {
      var check = this.$refs.list.data.some(
        (x) =>
          ((x.InAmount == 0 && x.OutAmount == 0) ||
            (x.InAmount == null && x.OutAmount == null)) &&
          (x.SourceNo == "" || x.SourceNo == null)
      );
      if (check) {
        this.$message.warning("收入与支出至少填写一项");
        return;
      }
      var rows = this.$refs.list.data.filter((x) => x.LeftAmountOrg != null);
      rows = rows.filter((x) => x.T != null);

      var amount = rows.some(
        (x) =>
          ((x.InAmount == 0 && x.OutAmount == 0) ||
            (x.InAmount == null && x.OutAmount == null)) &&
          (x.SourceNo == "" || x.SourceNo == null)
      );
      console.log(amount);
      console.log("保存", rows);
      if (amount) {
        this.$message.warning("收入与支出至少填写一项");
        return;
      }

      this.DelData.forEach((x) => rows.push(x));

      rows.forEach((item) => {
        if (item.LeftAmountOrg > 0) {
          item.Direction = "借";
        } else if (item.LeftAmountOrg < 0) {
          item.Direction = "贷";
        } else if (item.LeftAmountOrg == 0) {
          item.Direction = "平";
        }
        if (!(item.InAmount > 0)) item.InAmount = 0;
        if (!(item.OutAmount > 0)) item.OutAmount = 0;
      });

      console.log("保存", rows);
      rows = rows.filter((x) => x.CashierNo != "期初余额");
      if (rows.length > 0) {
        var loading = this.$loading({
          lock: true,
          text: "正在保存...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        console.log("调用");
        this.api.saveList(rows).then((res) => {
          console.log("res", res);
          loading.close();
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.reload();
          } else {
            this.$message.error("保存失败");
            this.reload();
          }
        });
      } else {
        this.$message.success("保存成功");
      }
    },
  },
};
</script>
